import {
  Pagination,
  Table,
  TableBody,
  TableCell,
  TableColumn,
  TableHeader,
  TableRow,
} from '@nextui-org/react';
import React from 'react';

import { IParceiro } from '../../../interfaces/response/Parceiros/IParceiro';
import useParceirosTable from './hooks/useParceirosTable';

export interface IParceirosTableProps {
  parceiros: IParceiro[];
  onRowClick?: (parceiro: IParceiro) => void;

  /** texto do filtro (sigla ou CEP) */
  filter?: string;
}

const getRowKey = (p: IParceiro): string => {
  const fallback = `${p.sigla ?? ''}-${p.cepInicio ?? ''}-${p.cepFim ?? ''}`;
  return (p.id ?? fallback) as string;
};

const ParceirosTable: React.FC<IParceirosTableProps> = ({
  parceiros,
  onRowClick,
  filter = '',
}): JSX.Element => {
  const {
    cellData,
    columns,
    handleRowClick,
    setSortDescriptor,
    sortDescriptor,
    pagedParceiros,
    page,
    setPage,
    totalPages,
  } = useParceirosTable({ parceiros, onRowClick, filter });

  return (
    <div className="flex flex-col gap-3">
      <Table
        aria-label="Tabela de parceiros"
        selectionMode="single"
        onRowAction={handleRowClick}
        sortDescriptor={sortDescriptor}
        onSortChange={setSortDescriptor}
      >
        <TableHeader columns={columns}>
          {({ key, name }) => (
            <TableColumn key={key} allowsSorting>
              {name}
            </TableColumn>
          )}
        </TableHeader>

        <TableBody
          items={pagedParceiros}
          emptyContent="Nenhum parceiro no momento"
        >
          {(item) => (
            <TableRow key={getRowKey(item)}>
              {(columnKey) => (
                <TableCell>
                  <p className="text-foreground-600">
                    {cellData(item, columnKey as string)}
                  </p>
                </TableCell>
              )}
            </TableRow>
          )}
        </TableBody>
      </Table>

      {totalPages > 1 && (
        <div
          className="flex w-full justify-center"
          style={{ marginBottom: 48, marginTop: 16 }}
        >
          <Pagination
            page={page}
            total={totalPages}
            onChange={setPage}
            showControls
          />
        </div>
      )}
    </div>
  );
};

export default ParceirosTable;
